// Generated by purs version 0.15.15
import * as Ouroboros_Programs_Controllers_DemographicSurvey from "../Ouroboros.Programs.Controllers.DemographicSurvey/index.js";
var mkDemographicSurveyEnv = function (input) {
    return {
        loading: input.kernel.loading,
        paymentClient: input.kernel.paymentClient,
        navigate: input.kernel.navigate,
        taskRunner: input.kernel.taskRunner,
        promoCode: input.promoCode,
        homeRoute: input.homeRoute
    };
};
var buildDemographicSurveyViewProps = function (input) {
    var controller = Ouroboros_Programs_Controllers_DemographicSurvey.mkDemographicSurveyController(mkDemographicSurveyEnv(input));
    return {
        onSubmit: function (survey) {
            return Ouroboros_Programs_Controllers_DemographicSurvey.runDemographicSurveyAction(controller.submit(survey));
        }
    };
};
export {
    buildDemographicSurveyViewProps
};
//# sourceMappingURL=index.js.map
